import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#635BFF",
      "fill-rule": "evenodd",
      d: "M8.765 9.53c0-1.372 1.109-1.9 2.945-1.9 2.633 0 5.96.81 8.592 2.251V1.618C17.427.458 14.586 0 11.71 0 4.677 0 0 3.727 0 9.952c0 9.705 13.165 8.158 13.165 12.343 0 1.617-1.385 2.145-3.326 2.145-2.875 0-6.548-1.196-9.458-2.814v8.37C3.603 31.402 6.86 32 9.84 32 17.046 32 22 28.378 22 22.084 21.965 11.604 8.765 13.468 8.765 9.53",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }